import React, { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { Form } from 'react-bootstrap';
import UserService from '../../services/userService';
import { ToastType, useToast } from '../toast/ToastProvider';
import { useTranslation } from 'react-i18next';

const Login = () => {
    const { t } = useTranslation();
    const navigate = useNavigate();
    const [formData, setFormData] = useState({ email: '', password: '' });
    const { showToast } = useToast();
    const [rememberMe, setRememberMe] = useState(false);
    const { i18n } = useTranslation();
    const isRtl = i18n.language === 'he';

    useEffect(() => {
        // Load saved email from sessionStorage
        const savedEmail = localStorage.getItem('rememberedEmail');
        if (savedEmail) {
            setFormData((prev) => ({ ...prev, email: savedEmail })); // Ensure formData remains an object
            setRememberMe(true);
        }
    }, []);
    

    const handleNavigateToRegister = () => {
        navigate('/register');
    };

    const handleNavigateToForgotPassword = () => {
        localStorage.setItem('rememberedEmail', formData.email);
        navigate('/forgot-password');
    };

    const handleChange = (e: React.ChangeEvent<HTMLInputElement>) => {
        setFormData({ ...formData, [e.target.name]: e.target.value });
    };
    
    const handleLogin = async (e: React.FormEvent) => {
        e.preventDefault();

        try {
            const response = await UserService.login(formData, navigate);
            const { token, userId, name, email, language, activeClinicId } = response;

            // Store token & user ID in sessionStorage
            sessionStorage.setItem('token', token);
            sessionStorage.setItem('userId', userId);
            sessionStorage.setItem('name', name);
            sessionStorage.setItem('email', email);
            sessionStorage.setItem('activeClinicId', activeClinicId);
            i18n.changeLanguage(language); // <-- Apply user language

            if (rememberMe) {
                localStorage.setItem('rememberedEmail', formData.email);
            } else {
                localStorage.removeItem('rememberedEmail');
            }

            navigate('/calendar');
        } catch (error : any) {
            showToast(t(`toastMessages.USERNAME_OR_PASSWORD_INCORRECT`), ToastType.Warning);
        }
    };

    return (
        <div className="container-scroller">
            <div className="container-fluid page-body-wrapper full-page-wrapper">
                <div className="row w-100 m-0">
                    <div className="content-wrapper full-page-wrapper d-flex align-items-center auth login-bg">
                        <div className="card col-lg-4 mx-auto">
                            <div className="card-body px-5 py-5">
                                <h3 className="card-title text-left mb-3">{t('login')}</h3>
                                <form>
                                    <div className="form-group">
                                        <label className="text-gray">{t('email')}</label>
                                        <input type="email" placeholder={t('email')} value={formData.email} onChange={handleChange} className="form-control p_input input-bg-dark text-white" name="email" />
                                    </div>
                                    <div className="form-group">
                                        <label className="text-gray">{t('password')}</label>
                                        <input type="password" value={formData.password} onChange={handleChange} placeholder={t('password')} className="form-control p_input input-bg-dark text-white" name="password" />
                                    </div>
                                    <div className="form-group d-flex align-items-center justify-content-between">
                                        <Form.Check
                                                type="checkbox"
                                                label={t('remember-me')}
                                                className={`mt-2 text-gray d-flex align-items-center ${isRtl ? 'me-2' : 'ms-2'}`}
                                                id="loginRemember"
                                                checked={rememberMe}
                                                onChange={() => setRememberMe(!rememberMe)}
                                            />
                                        <a className="btn btn-link" onClick={handleNavigateToForgotPassword}>{t('forgot-password')}</a>
                                    </div>
                                    <div className="text-center">
                                        <button type="submit" onClick={handleLogin} className="btn btn-primary btn-block enter-btn">{t('login')}</button>
                                    </div>
                                    <p className="sign-up">{t('dont-have-account')}<a className="btn btn-link" onClick={handleNavigateToRegister}> {t('register')}</a></p>
                                </form>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default Login;
